import React from 'react';
import { DashboardLayout } from './DashboardLayout';
import { DashboardHome } from './DashboardHome';
import { ParticipantPreview } from './ParticipantPreview';
export function DashboardPage() {
  return <DashboardLayout pageTitle="Dashboard" breadcrumb="Leadership Reset Retreat" data-id="element-1416">
      <DashboardHome data-id="element-1417" />
      <div className="mt-8" data-id="element-1418">
        <ParticipantPreview data-id="element-1419" />
      </div>
    </DashboardLayout>;
}